import CustomLink from '@/shared/components/customLink'
import { BallIcon } from '@/shared/Icons'
import { BowlerDataRowType } from '../types'

export default function BowlerDataRow({ bowler, table, isActiveBowler }: BowlerDataRowType) {
  const b = bowler?.oBowler
  const playerSlug = b?.oSeo?.sSlug
  const playerName = (
    <>
      {b?.sFullName || b?.sShortName}
      {b?.isCaptain && <span className="ps-1">(c)</span>}
      {b?.isWk && <span className="ps-1">(wk)</span>}
      {b?.bImpactPlayer && (
        <span className="px-0.5 bg-green-600 text-[10px] rounded-sm text-white leading-4">IMP</span>
      )}
      {isActiveBowler ? <BallIcon /> : null}
    </>
  )
  return (
    <tr className={`${bowler.highlight && 'highlight'}`}>
      {b?.eTagStatus === 'a' ? (
        <td className="">
          {playerSlug ? (
            <CustomLink
              href={`/${playerSlug}`}
              prefetch={false}
              className="flex items-center gap-2 w-fit"
            >
              {playerName}
            </CustomLink>
          ) : (
            <span className="flex items-center gap-2 w-fit">{playerName}</span>
          )}
        </td>
      ) : (
        <td className="">
          <span className="flex items-center gap-2 w-fit">{playerName}</span>
        </td>
      )}
      {Object.keys(table)?.map((value: string) => {
        return <td key={value}>{bowler[value]}</td>
      })}
    </tr>
  )
}
